module.exports = __webpack_public_path__ + "static/media/vois_logo.83534a9f.png";